var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Apresentacao'),_c('Menu',{attrs:{"rotas":_vm.routes}}),_c('transition',{attrs:{"name":"pagina"}},[_c('router-view')],1),_c('Rodape')],1)}
var staticRenderFns = []

export { render, staticRenderFns }